import { makeStyles } from 'tss-react/mui'

export const APP_BAR_HEIGHT = 64

const useStyles = makeStyles()(() => ({
  root: {
    height: APP_BAR_HEIGHT,
    minHeight: APP_BAR_HEIGHT,
    maxHeight: APP_BAR_HEIGHT,
  },
}))

/** Give space between the end of content for a bottom AppBar. Also moves the
 * HelpScout beacon. */
const BottomAppBarSpacer: React.FC<React.PropsWithChildren<{}>> = () => {
  const { classes } = useStyles()

  return (
    <>
      <div className={classes.root} />
    </>
  )
}

export default BottomAppBarSpacer
